import { isStatsigInitialized } from '@eventbrite/statsig';
import React from 'react';
import type { Event, LegacyConversionBarProps } from '../../../types/index';
import {
    ConversionBar,
    ConversionBarComponentProps,
} from './ConversionBar/ConversionBar';
import './ConversionBarContainer.scss';
import {
    isEventEnabledInMultiTicketsExperiment,
    isTicketSelectionExcludedInListings,
} from './isTicketSelectionExcludedInListings';
import { TicketSelectionIframe } from './TicketSelectionIframe/TicketSelectionIframe';

export interface ConversionBarContainerProps
    extends ConversionBarComponentProps,
        LegacyConversionBarProps {
    compactCheckoutDisqualifications: Event['compactCheckoutDisqualifications'];
    ticketsInfo: Event['ticketsInfo'];
    salesStatus: Event['salesStatus']['sales_status'];
}

export const ConversionBarContainer = (props: ConversionBarContainerProps) => {
    const isMultiTicketEnabled = isEventEnabledInMultiTicketsExperiment();
    const ticketSelectionIframe = (
        <TicketSelectionIframe
            eventId={props.eventId}
            eventName={props.eventName as string}
            affiliateCode={props.affiliateCode}
            isPreview={props.isPreview}
            promoCode={props.promoCode}
            waitlistToken={props.waitlistToken}
            rsvpToken={props.rsvpToken}
            campaign_token={props.campaign_token}
        />
    );
    const isTicketSelectionExcluded = isTicketSelectionExcludedInListings({
        soldOut: props.compactCheckoutDisqualifications.sold_out,
        reservedSeating:
            props.compactCheckoutDisqualifications.reserved_seating,
        moreThanOneTicket:
            props.compactCheckoutDisqualifications.more_than_one_ticket,
        isSalesEnded: props.compactCheckoutDisqualifications.is_sales_ended,
        isRsvp: props.compactCheckoutDisqualifications.is_rsvp,
        isPostponed: props.compactCheckoutDisqualifications.is_postponed,
        isCanceled: props.compactCheckoutDisqualifications.is_canceled,
        hasWaitlist: props.compactCheckoutDisqualifications.has_waitlist,
        hasWaitingRoom: props.compactCheckoutDisqualifications.has_waiting_room,
        hasDiscounts: props.compactCheckoutDisqualifications.has_discounts,
        hasAddons: props.compactCheckoutDisqualifications.has_addons,
        discountCode: props.compactCheckoutDisqualifications.discount_code,
        hasDonations: props.compactCheckoutDisqualifications.has_donations,
        hasInventoryTiers:
            props.compactCheckoutDisqualifications.has_inventory_tiers,
        externalTicketsAreAvailable: props.externalTicketsAreAvailable,
        salesStatus: props.salesStatus,
        isSeriesParent: props.isSeriesParent,
    });

    if (!isTicketSelectionExcluded) {
        return ticketSelectionIframe;
    }
    if (!isStatsigInitialized()) {
        return null;
    }

    return isMultiTicketEnabled ? (
        ticketSelectionIframe
    ) : (
        <ConversionBar {...props} />
    );
};
